import { useAppSelector } from '@brands/hooks/useReduxHook';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import CaseChatWindowNotPatient from '../../../default/Dashboard/CaseChatWindow/CaseChatWindow';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import CaseChatWindow from './CaseChatWindow';

const CaseChatWindowCheck: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.CareAdvisor:
    case UserRoleName.Collector:
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.Admin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Patient:
    case UserRoleName.Provider:
      component = <CaseChatWindow />;
      break;

    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default CaseChatWindowCheck;
